import { render, staticRenderFns } from "./DetailBidder.vue?vue&type=template&id=3aa5c9ca&"
import script from "./DetailBidder.vue?vue&type=script&lang=js&"
export * from "./DetailBidder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa5c9ca')) {
      api.createRecord('3aa5c9ca', component.options)
    } else {
      api.reload('3aa5c9ca', component.options)
    }
    module.hot.accept("./DetailBidder.vue?vue&type=template&id=3aa5c9ca&", function () {
      api.rerender('3aa5c9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/successfulBidder/views/components/DetailBidder.vue"
export default component.exports